import type { ShippingSettings } from "./types";
import { resolveShippingMethod } from "./shippingFee";

/** Policy-safe shipping line for SEO and AI discovery metadata (no destination claims). */
export function buildSiteMetaShippingSnippet(settings: ShippingSettings): string {
  const standard = settings.shippingMethods.find(
    (method) => method.methodId === "standard" && method.enabled,
  );
  if (!standard) {
    return "Shipping options available at checkout";
  }
  if (standard.fee === 0) {
    return "Free standard shipping";
  }
  return "Standard shipping available";
}

export function getMarketTransitWindow(
  settings: ShippingSettings,
  countryCode?: string,
): { min: number; max: number } {
  const market = countryCode === "UK" || countryCode === "GB" ? "UK" : "INTL";
  const override = settings.marketTransitOverrides.find((row) => row.market === market);
  if (override) {
    return { min: override.transitDaysMin, max: override.transitDaysMax };
  }
  const standard = resolveShippingMethod(settings, "standard");
  return {
    min: standard?.transitDaysMin ?? 5,
    max: standard?.transitDaysMax ?? 12,
  };
}
